import React,{useEffect,useRef} from 'react'
import Navbar from '../../components/user/Navbar'
import FooterComponent from '../../components/user/FooterComponent'
import { Link } from 'react-router-dom'
import ContactButtons from '../../components/user/ContactButtons'
import { useLocation } from 'react-router-dom';



const ConfirmBookingPage = () => {




  return (
    <div>
   
          <Navbar />
    

        <div className="error-page">
            <div>
                {/* <div className="error-page-heading-1">Thanks For Booking</div> */}
                <div className="error-page-heading-1">Your Service Is Confirmed</div>
                <div className="error-page-heading-2">Our expert will contact you shortly</div>
                {/* <div className="error-page-heading-3">Contact: <Link target='blank' to="tel:+919658153153"> +91 9658-153-153</Link></div> */}
                <br />
                <div className="error-page-button"><Link  onClick={() =>  window.history.back()}>Go Back</Link></div>
                <br />
                {/* <div className="error-page-button"><Link to="tel:+919658153153" target="_blank"><i className="fa-solid fa-phone"></i> Book By Call</Link></div> */}
            </div>
        </div>

        <FooterComponent/>
        {/* <ContactButtons/> */}
    </div>
  )
}

export default ConfirmBookingPage